import { render, staticRenderFns } from "./LayoutMomo.vue?vue&type=template&id=4a7fdb1d&"
import script from "./LayoutMomo.vue?vue&type=script&lang=js&"
export * from "./LayoutMomo.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMomo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports